import { render, staticRenderFns } from "./NsTopnavProductLine.vue?vue&type=template&id=13455c7c&scoped=true&"
import script from "./NsTopnavProductLine.vue?vue&type=script&lang=js&"
export * from "./NsTopnavProductLine.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavProductLine.vue?vue&type=style&index=0&id=13455c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13455c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13455c7c')) {
      api.createRecord('13455c7c', component.options)
    } else {
      api.reload('13455c7c', component.options)
    }
    module.hot.accept("./NsTopnavProductLine.vue?vue&type=template&id=13455c7c&scoped=true&", function () {
      api.rerender('13455c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavProductLine.vue"
export default component.exports